import { CmsSignIn } from '../../models/cms/cms-sign-in.interface';
import { mockCmsSignInForm } from './cms-sign-in-form.mock';

export const mockCmsSignIn: CmsSignIn = {
  ...mockCmsSignInForm,
  signInButtonLabel: 'signInButtonLabel',
  signInDescription: 'signInDescription',
  signInTitle: 'signInTitle',
};
